export function computeTargetGap(firstSystolic, lastSystolic) {
  if (firstSystolic == null || lastSystolic == null) return null;
  return lastSystolic - Math.max(firstSystolic - 15, 130);
}
